// Fix 3 (bug de chip duplicado — auto-resolución de sincronización): cuando
// el servidor unifica animales duplicados (mismo chip subido desde dos
// dispositivos) nunca se muestra un error — solo un aviso informativo y
// agrupado, una vez que termina el ciclo de sincronización.
import { useEffect, useRef } from "react";
import { onSyncState } from "@/lib/sync";
import { toast } from "sonner";

export function MergedSyncNotice() {
  const lastAt = useRef(null);
  useEffect(() => {
    const off = onSyncState((s) => {
      const mergedCount = s.phase === "idle" ? s.last?.push?.merged : 0;
      if (mergedCount > 0 && s.last.at !== lastAt.current) {
        lastAt.current = s.last.at;
        toast.info(
          mergedCount === 1
            ? "Se unificó 1 animal que estaba cargado dos veces."
            : `Se unificaron ${mergedCount} animales que estaban cargados dos veces.`,
          { duration: 6000 }
        );
      }
    });
    return off;
  }, []);
  return null;
}
